import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { VelocityComponent } from 'velocity-react';

import Icon from './icon/Icon';
import Link from './Link';
import Spinner from './spinner/Spinner';

import { EVENT_GROUP_ALL } from '../carts/actions';

import { getCurrentCart, cartIsLoading } from '../carts/constants';
import { getUserData } from '../user/selectors';
import TranslatedCopy from '../intl/TranslatedCopy';

export const ShoppingCartIcon = ({ cartHasLoaded, cartCount, isLoading, currentUsername, cartUser }) => {
  const isOtherUsersCart = cartHasLoaded && cartUser.toLowerCase() !== currentUsername.toLowerCase();

  return (
    <div className='cartIcon' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
      <span className='otherUsersCart'>
        <VelocityComponent animation={isOtherUsersCart ? 'fadeIn' : 'fadeOut'}>
          <div className='body-4 text-color-secondary pr2-sm'>
            <TranslatedCopy id='cartIcon.viewingOtherCart' values={{ username: cartUser }} />
          </div>
        </VelocityComponent>
      </span>
      <Link
        to='/cart'
        className='pr5-sm'
        data-desc='navigationMain__link_cart'
        aria-label={`${cartCount} items in cart`}
      >
        <Icon name='shopping-cart' alt='cart' className='viewport__header_shopping_cart'>
          {cartCount > 0 && (
            <div
              className='navigationMain__link_cart-length d-sm-ib text-color-primary-light u-bold ta-sm-c'
              data-desc='navigationMain__cart_count_badge'
            >
              <div className={classnames('cart-length-value', { 'non-visible': isLoading })}>{cartCount}</div>
              <div className={classnames('navigationMain__spinner', { 'non-visible': !isLoading })}>
                <Spinner />
              </div>
            </div>
          )}
        </Icon>
      </Link>
    </div>
  );
};

ShoppingCartIcon.defaultProps = {
  cartUser: ''
};

ShoppingCartIcon.propTypes = {
  cartHasLoaded: PropTypes.bool.isRequired,
  cartCount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  currentUsername: PropTypes.string.isRequired,
  cartUser: PropTypes.string
};

export const mapStateToProps = state => {
  const currentCart = getCurrentCart(state);

  return {
    cartHasLoaded: currentCart.id.length > 0,
    cartCount: currentCart.products.length,
    cartUser: currentCart.createdBy,
    isLoading: cartIsLoading(state, EVENT_GROUP_ALL),
    currentUsername: getUserData(state).email
  };
};

const connector = connect(mapStateToProps, {});

export default connector(ShoppingCartIcon);
